import { styled } from '@mui/system'

export const Container = styled('div')`
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: hidden;
`

export const Header = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: ${(props) =>
    props.theme.palette['$color-background-primary']};
`

export const AppContainer = styled('div')`
  flex: 1;
  overflow-y: auto;
`

export const SentinelContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 35%;
  height: 100%;
  border-left: 1px solid
    ${(props) => props.theme.palette['$color-border-primary']};
`
